import { useEffect, useState } from 'react';

export interface Route {
  path: string;
  segments: string[];
}

function parseHash(): Route {
  const raw = window.location.hash.replace(/^#/, '');
  const path = raw.length > 0 ? raw : '/home';
  const segments = path.split('?')[0].split('/').filter(Boolean);
  return { path, segments };
}

export function navigate(path: string, options: { replace?: boolean; scroll?: boolean } = {}) {
  const target = `#${path.startsWith('/') ? path : `/${path}`}`;
  if (options.replace) {
    window.history.replaceState(null, '', target);
    window.dispatchEvent(new HashChangeEvent('hashchange'));
  } else {
    window.location.hash = target;
  }
  if (options.scroll !== false) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parseHash());

  useEffect(() => {
    const onChange = () => setRoute(parseHash());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  return route;
}
